<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <div class="vx-row pt-2">
        <vs-button size="small" class="mr-2 px-3" color="primary" type="filled" icon-pack="feather" icon="icon-printer" @click="printVoucher"></vs-button>
        <vs-button size="small" class="mr-2 px-3" color="success" type="filled" icon-pack="feather" icon="icon-edit" @click="editRecord" v-if="isCreator"></vs-button>
        <vs-button size="small" class="px-3" color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord" v-if="isCreator"></vs-button>
      </div>
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  computed: {
    isCreator () {
      return this.params.data.can_modify === true
    }
  },
  methods: {
    printVoucher () {
      this.params.printVoucher(this.params.data)
    },
    editRecord () {
      this.$router.push(`/bank-account-cashflow/edit/${this.params.data.id}`).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Perhatian',
        text: `Anda akan menghapus "${this.params.data.proof}" ?`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const self = this
      this.$store.dispatch('bankCashflow/deleteBankCashflow', this.params.data.id)
        .then(function () {
          self.params.getBankCashflow()
          self.showDeleteSuccess()
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err
          })
        })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Berhasil',
        text: 'Bank Account Cashflow has been deleted'
      })
    }
  }
}
</script>
